import React from 'react';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import {
    KPICardWrapper,
    KPICardTitle,
    KPICardContentWrapper,
    KPICardValue,
    KPICardChangeRow,
    KPICardChangeText,
    KPICardChangeBadge
} from './style';

/**
 * KPI Card Component - A simple, reusable card for displaying key performance indicators
 * @param {string} title - The title/label of the KPI (e.g., "Total Shipment")
 * @param {string|number} value - The main value to display (e.g., "8,153")
 * @param {Object} change - Change information object
 * @param {string} change.value - Change percentage (e.g., "+2.34%")
 * @param {boolean} change.isPositive - Whether the change is positive or negative
 * @param {string} change.text - Additional text (e.g., "vs last week")
 */
const KPICard = ({
    title,
    value,
    change
}) => {
    return (
        <KPICardWrapper>
            <KPICardTitle>{title}</KPICardTitle>
            <KPICardContentWrapper>
                <KPICardValue>{value}</KPICardValue>
                {change && (
                    <KPICardChangeRow>
                        <KPICardChangeText>{change.text}</KPICardChangeText>
                        <KPICardChangeBadge $positive={change.isPositive}>
                            {change.isPositive ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                            {change.value}
                        </KPICardChangeBadge>
                    </KPICardChangeRow>
                )}
            </KPICardContentWrapper>
        </KPICardWrapper>
    );
};

export default KPICard;

